import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty, isEqual } from "lodash";
import React, { memo } from "react";
import { CHANGE_PREV_EPG, SECONDS_TO_REVERT } from "@config/constants";
import BackwardButton from "./controls/BackwardButton";
import ForwardButton from "./controls/ForwardButton";
import LiveButton from "./controls/LiveButton";
import NextButton from "./controls/NextButton";
import PlayButton from "./controls/PlayButton";
import PrevButton from "./controls/PrevButton";
import VolumeButton from "./controls/VolumeButton";
var PlaybackButtons = function(param) {
    var i18n = param.i18n, videoPlayer = param.videoPlayer, actions = param.actions, screenType = param.screenType;
    var getButtonsData = function() {
        var epgs = videoPlayer.epgs;
        var currentTime = actions.getCurrentTime();
        var data = {
            prev: {},
            backward: {},
            play: {},
            forward: {},
            live: {},
            next: {}
        };
        // prev
        if (epgs && currentTime > CHANGE_PREV_EPG && isEmpty(epgs.prev)) {
            data.prev.dataTip = i18n.player.beginning;
        } else {
            data.prev.dataTip = "".concat(i18n.player.previous, " ").concat(epgs && epgs.prev ? epgs.prev.title : "");
        }
        // backward
        data.backward.dataTip = "".concat(i18n.player.backward, " ").concat(SECONDS_TO_REVERT, " ").concat(i18n.player.seconds);
        // play/pause
        if (!videoPlayer.video.paused) {
            data.play.dataTip = i18n.player.pause;
        } else {
            data.play.dataTip = i18n.player.play;
        }
        // forward
        data.forward.dataTip = "".concat(i18n.player.forward, " ").concat(SECONDS_TO_REVERT, " ").concat(i18n.player.seconds);
        // live
        data.live.dataTip = i18n.player.live;
        // next
        data.next.dataTip = ((videoPlayer.epgs || {}).next || {}).title;
        return data;
    };
    var playPrevVideoHandler = function() {
        var currentTime = actions.getCurrentTime();
        if (!videoPlayer.video.disablePrevButton) {
            if (currentTime <= CHANGE_PREV_EPG) {
                videoPlayer.epgs.prev.startPosition = 0;
                actions.changeVideo(videoPlayer.channelId, videoPlayer.epgs.prev);
            } else {
                actions.setCurrentTime(4);
                actions.chromecastSeekRequest(0);
            }
        }
    };
    var backwardVideoHandler = function(isTrigeredFromKeyboard) {
        var currentTime = actions.getCurrentTime();
        if (!videoPlayer.video.disableBackwardButton) {
            if (currentTime < SECONDS_TO_REVERT && videoPlayer.video.hasStarted) {
                videoPlayer.epgs.prev.startPosition = videoPlayer.epgs.prev.stop - videoPlayer.epgs.prev.start - SECONDS_TO_REVERT;
                actions.changeVideo(videoPlayer.channelId, videoPlayer.epgs.prev);
            } else {
                actions.backward(SECONDS_TO_REVERT, isTrigeredFromKeyboard);
            }
        }
    };
    var forwardVideoHandler = function(isTrigeredFromKeyboard) {
        var currentTime = actions.getCurrentTime();
        var duration = actions.getDuration();
        if (!videoPlayer.video.disableForwardButton) {
            if (duration - currentTime < SECONDS_TO_REVERT && videoPlayer.video.hasStarted) {
                videoPlayer.epgs.next.startPosition = 0;
                actions.changeVideo(videoPlayer.channelId, videoPlayer.epgs.next);
            } else {
                actions.forward(SECONDS_TO_REVERT, isTrigeredFromKeyboard);
            }
        }
    };
    var returnToLiveHandler = function() {
        if (!videoPlayer.video.disableLiveButton) {
            actions.setVideoToLive();
        }
    };
    var nextVideoHandler = function() {
        if (!videoPlayer.video.disableNextButton) {
            videoPlayer.epgs.next.startPosition = 0;
            actions.changeVideo(videoPlayer.channelId, videoPlayer.epgs.next);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "playback-buttons",
        children: [
            /*#__PURE__*/ _jsx(PrevButton, {
                disabled: videoPlayer.video.disablePrevButton,
                getButtonsData: getButtonsData,
                onClick: playPrevVideoHandler
            }),
            /*#__PURE__*/ _jsx(BackwardButton, {
                disabled: videoPlayer.video.disableBackwardButton,
                getButtonsData: getButtonsData,
                onClick: backwardVideoHandler
            }),
            /*#__PURE__*/ _jsx(PlayButton, {
                disabled: !screenType.web,
                getButtonsData: getButtonsData,
                onClick: actions.togglePlay,
                i18n: i18n,
                screenType: screenType,
                paused: videoPlayer.video.paused
            }),
            /*#__PURE__*/ _jsx(ForwardButton, {
                disabled: videoPlayer.video.disableForwardButton,
                getButtonsData: getButtonsData,
                onClick: forwardVideoHandler
            }),
            !screenType.web && /*#__PURE__*/ _jsx(VolumeButton, {
                i18n: i18n,
                screenType: screenType,
                videoPlayer: videoPlayer,
                actions: actions
            }),
            videoPlayer.video.isLiveEpg ? /*#__PURE__*/ _jsx(LiveButton, {
                disabled: videoPlayer.video.disableLiveButton,
                getButtonsData: getButtonsData,
                onClick: returnToLiveHandler
            }) : (videoPlayer.isVod ? !videoPlayer.video.disableNextButton : true) && /*#__PURE__*/ _jsx(NextButton, {
                disabled: videoPlayer.video.disableNextButton,
                getButtonsData: getButtonsData,
                onClick: nextVideoHandler
            })
        ]
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(PlaybackButtons, areEqual);
